import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
    
/**
    * Base
    */

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
let gltfScene;

const textureLoader = new THREE.TextureLoader()

const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('draco/')

const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

const bakedTexture = textureLoader.load('texture2k.jpg')
bakedTexture.flipY = false

const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture })
const wireframeMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true })

/**
    * Models
    */


gltfLoader.load(
  'mesh.glb',
  (gltf) =>
    {
      gltf.scene.traverse((child) =>
    {
      child.material = bakedMaterial
    })
    gltf.scene.scale.set(0.5, 0.5, 0.5)
      scene.add(gltf.scene)
      gltfScene = gltf.scene;
    }
);

const materialToggle = document.getElementById('material-toggle');

materialToggle.addEventListener('change', () => {
    gltfScene.traverse((child) => {
        if (child.isMesh) {
            child.material = materialToggle.checked ? wireframeMaterial : bakedMaterial;
        }
    });
});

/**
    * Sizes
    */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
    * Camera
    */
// Base camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 100)
camera.position.set(-2, 1, 2)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.target.set(0, 0, 0)
controls.enableDamping = true

/**
    * Renderer
    */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
    * Animate
    */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick();